var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gdpr-right"},[_c('dt',{staticClass:"gdpr-right__title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('dd',{staticClass:"gdpr-right__description"},[_vm._v("\n        "+_vm._s(_vm.description)+".\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }